import React from 'react';
import * as Styled from '../../styled';
import _ from 'lodash';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { InvestmentFilterElements } from '../InvestmentFilterElements';
import { FilterElements } from '../../FilterElements';
import GroupFragment from '../../../../containers/GroupFragment/GroupFragment';

interface Props {
	advisedPortfolioMin: string;
	advisedPortfolioMax: string;
	formikProps: any;
}

const AdvisedPortfolioFilter = (props: Props) => {
	const { handleChange, errors } = props.formikProps;
	return (
		<React.Fragment>
			<Styled.FilterLabel label="Total balance">
				<GroupFragment>
					<Styled.FieldWrapperSubRow>
						<Styled.FieldWrapperLeftSubCol md="6" sm="12">
							<Styled.FilterLabel label="$ min.">
								<Styled.ValidatedInput
									name="advisedPortfolioMin"
									placeholder="Any"
									onChange={handleChange}
									value={props.advisedPortfolioMin}
									data-id={InvestmentFilterElements.minAdvisedPortfolioFilterId}
									error={errors.advisedPortfolioMin}
									aria-describedby={
										InvestmentFilterElements.advisedPortfolioErrorId
									}
									className={
										errors.advisedPortfolioMin || errors.advisedPortfolioMax
											? FilterElements.validationError
											: null
									}
								/>
							</Styled.FilterLabel>
						</Styled.FieldWrapperLeftSubCol>
						<Styled.FieldWrapperRightSubCol md="6" sm="12">
							<Styled.FilterLabel label="$ max.">
								<Styled.ValidatedInput
									name="advisedPortfolioMax"
									placeholder="Any"
									onChange={handleChange}
									value={props.advisedPortfolioMax}
									data-id={InvestmentFilterElements.maxAdvisedPortfolioFilterId}
									error={
										errors.advisedPortfolioMax || errors.advisedPortfolioMin
									}
									aria-describedby={
										InvestmentFilterElements.advisedPortfolioErrorId
									}
								/>
							</Styled.FilterLabel>
						</Styled.FieldWrapperRightSubCol>
						<Styled.ErrorCol col="12">
							{errors.advisedPortfolioMin || errors.advisedPortfolioMax ? (
								<Styled.ValidationError
									id={InvestmentFilterElements.advisedPortfolioErrorId}
									data-id={InvestmentFilterElements.advisedPortfolioErrorId}
								>
									<Styled.ErrorIcon icon={faExclamationTriangle} />
									<span className="sr-only">Error, </span>
									{errors.advisedPortfolioMax || errors.advisedPortfolioMin}
								</Styled.ValidationError>
							) : null}
						</Styled.ErrorCol>
					</Styled.FieldWrapperSubRow>
				</GroupFragment>
			</Styled.FilterLabel>
		</React.Fragment>
	);
};

export default AdvisedPortfolioFilter;
